import History from '@react-spectrum/s2/icons/History';
import { iconStyle } from '@react-spectrum/s2/style' with { type: 'macro' };

import { ShortcutTooltip } from '@/components/ShortcutTooltip.tsx';
import { cn } from '@/utils/cn.ts';

interface ChatHistoryToggleProps {
	onToggle: () => void;
	isHistoryOpen: boolean;
	hasUnreadThreads?: boolean;
}

export const ChatHistoryToggle = ({
	onToggle,
	isHistoryOpen,
	hasUnreadThreads,
}: ChatHistoryToggleProps) => {
	return (
		<div className="group relative">
			<button
				type="button"
				onClick={onToggle}
				aria-label="Toggle chat history"
				aria-pressed={isHistoryOpen}
				className={cn(
					`flex h-8 w-8 items-center justify-center rounded-md
					transition-colors`,
					isHistoryOpen
						? 'bg-[var(--text-primary)] text-white'
						: 'text-[var(--text-primary)] hover:bg-[var(--glass-bg-hover)]',
				)}
			>
				<History
					styles={
						isHistoryOpen
							? iconStyle({ size: 'M', color: 'white' })
							: iconStyle({ size: 'M' })
					}
				/>
			</button>
			{hasUnreadThreads && (
				<span
					data-testid="chat-history-unread-dot"
					className={cn(
						'absolute top-0 right-0 h-2 w-2 rounded-full ring-2',
						isHistoryOpen
							? 'bg-white ring-[var(--text-primary)]'
							: 'bg-beacon-unread ring-white',
					)}
				/>
			)}
			<ShortcutTooltip label="Chat history" shortcut="⌘ /" placement="right" />
		</div>
	);
};
